import { memo, useCallback } from 'react'

import { Radio } from 'core-components/library/radio'

import { useFormField } from '../../hooks'
import { IFormField } from '../../models'
import { ReadOnlyField } from '../readOnlyField'

interface Props<T> extends IFormField<T> {
  className?: string
  options: Array<T>
  inline?: boolean
}

const typedMemo: <T>(c: T) => T = memo

export const FormRadioGroup = typedMemo(<T extends string>(props: Props<T>) => {
  const { value, handleChange } = useFormField(props)

  const onChangeHandler = useCallback(
    (value: T) => {
      handleChange(value)
    },
    [handleChange]
  )

  if (props.isReadOnly) {
    return <ReadOnlyField label={props.label} value={value} />
  }

  return (
    <div style={{ display: 'flex', flexDirection: props.inline ? 'row' : 'column', gap: '8px' }}>
      {props.options.map((option, index) => (
        <Radio
          key={index}
          value={option}
          checked={value === option}
          onChange={() => onChangeHandler(option)}
          label={option}
          disabled={props.isDisabled}
          className={props.className}
          inline={props.inline}
        />
      ))}
    </div>
  )
})
